import { Component, OnInit,Input } from '@angular/core';

import { HelperService,ErrorClass } from '../../../api/helper.service'

//Cart imports
import { CartService } from '../../../api/cart.service'
import { CartClass } from '../../../class/cartclass'

//Payment Imports
import { PaymentService } from '../../../api/payment.service'
import { PaymentClass } from '../../../class/paymentclass'

//Fundraiser Imports
import { FundraiserService } from '../../../api/fundraiser.service'
import { FundraiserClass,FdDetail } from '../../../class/fundraiserclass'

//Item Search
import { ItemWebsiteService } from '../../../api/item-website'
import { Items } from '../../../class/itemclassweb'
import { DropDownClass } from '../../../class/dropdownclass';

import { FileService } from '../../../api/file.service'


//Recaptcha
import { RecaptchaService } from '../../../api/recaptcha.service'
import { JsonPipe } from '@angular/common';

import { UTMClass } from '../../../class/utmclass'
import { UTMService} from '../../../api/utm.service'

declare var grecaptcha: any;

@Component({
  selector: 'app-utm',
  templateUrl: './utm.component.html',
  styleUrls: ['./utm.component.scss']
})
export class UtmComponent implements OnInit {


@Input() utm: UTMClass = new UTMClass


 public saving_item:Boolean = false;
 

  //Cart Variables
  cart:CartClass = new CartClass

  constructor(
    private api:UTMService,
    private cartAPI:CartService,
    private paymentAPI:PaymentService,
    private fundAPI:FundraiserService,
    private help:HelperService,
    private fileAPI:FileService,
    private recapService:RecaptchaService,
  ) { }

  ngOnInit() {

  }

  saveUTM(){
    this.saving_item = true
    this.api.saveUTM(this.utm).subscribe(
      (data:any) => {
        this.help.msgbox('Success',data)
        this.saving_item = false
      },
      (err:any) => {
        this.help.msgboxError('Error',JSON.stringify(err))
        this.saving_item = false
      }
    )
  }

  


}

